import { Link } from "react-router-dom";
import LazyImage from './LazyImage';

// The actual grid-of-children rendering for a catalog-type component embedded in a page's
// layout (TemplateRows.js). `rows` is the item layout's row/column/component structure,
// used only to figure out which field is each child's title/subtitle — it's not rendered itself.
function CatalogItemsGrid({ children, rows, elementsInARow, currentSlug }) {
    const cols = elementsInARow || 3;

    const allProperties = (rows || []).flatMap(row => row.columns || []).flatMap(col => col.components || []);
    const titleProp = allProperties.find(p => p.as_title === true);
    const subtitleProp = allProperties.find(p => p.as_subtitle === true);

    const getItemTitle = (page) => {
        if (titleProp) {
            const val = page.template?.props?.[titleProp.name];
            if (val) return val;
        }
        return page.caption || page.title;
    };

    const formatDate = (value) => {
        const [y, m, d] = value.split('-').map(Number);
        const date = new Date(y, m - 1, d);
        const month = date.toLocaleDateString('en-US', { month: 'short' });
        return `${month} ${date.getDate()}, ${date.getFullYear()}`;
    };

    const getItemSubtitle = (page) => {
        if (!subtitleProp) return null;
        let val = page.template?.props?.[subtitleProp.name];
        if (!val) return null;
        if (subtitleProp.type === 'date') val = formatDate(val);
        const prefix = subtitleProp.meta?.prefix || '';
        const suffix = subtitleProp.meta?.suffix || '';
        return [prefix, val, suffix].filter(Boolean).join(' ');
    };

    return (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: `repeat(${cols}, 1fr)`,
                gap: "12px",
                width: "100%"
            }}
        >
            {(children || []).map((page, idx) => (
                <Link key={idx} to={`/${currentSlug}/${page.slug}`} className="category-block" style={{ display: "block", cursor: "pointer", textDecoration: "none" }}>
                    <div style={{ overflow: "hidden" }}>
                        {page.preview ? (
                            <LazyImage
                                src={page.preview}
                                alt={getItemTitle(page)}
                                className="catalog-image"
                                style={{ aspectRatio: "16 / 9", width: "100%" }}
                                imgStyle={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }}
                            />
                        ) : (
                            <div className="catalog-image" style={{ backgroundColor: "#f0ebe0", aspectRatio: "16 / 9", width: "100%" }} />
                        )}
                    </div>
                    <div style={{ padding: "8px 4px 0" }}>
                        <span className="imageTitle">{getItemTitle(page)}</span>
                        {getItemSubtitle(page) && (
                            <div className="imageMaterial">{getItemSubtitle(page)}</div>
                        )}
                    </div>
                </Link>
            ))}
        </div>
    );
}

export default CatalogItemsGrid;
